export default __webpack_public_path__ + "static/media/actionsChart.33ff6a9b.png";